__webpack_require__.p = "/arabic/";